module.exports = __webpack_public_path__ + "img/step1.3c0af687.gif";